// @flow
export const userInfoSelector = (state: ReduxState) => state.userInfo;
